import { PropsWithChildren, ReactNode, useState } from "react";
import { Card } from "react-bootstrap";
import { Icon, fas } from "../..";

export interface FormCardProps extends PropsWithChildren {
    title?: ReactNode;
    suppressMargin?: boolean;
    dark?: boolean;
    footer?: ReactNode;
    collapsible?: boolean;
    headerLeftElement?: ReactNode;
    headerRightElement?: ReactNode;
    className?: string;
    isStartCollapsed?: boolean;
}

export function FormCard({
    title,
    suppressMargin,
    dark,
    footer,
    collapsible,
    headerLeftElement,
    headerRightElement,
    className,
    children,
    isStartCollapsed,
}: Readonly<FormCardProps>) {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(isStartCollapsed ?? false);

    const handleHeaderClick = () => {
        if (collapsible) {
            setIsCollapsed((prev) => !prev);
        }
    };

    return (
        <Card className={`w-100 ${!suppressMargin && "mb-2"} ${className ?? ""}`}>
            {!!title && (
                <Card.Header
                    className={`d-flex justify-content-between align-items-center bg-primary text-white ${collapsible ? "clickable" : ""}`}
                    onClick={handleHeaderClick}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <span>{title}</span>
                        {headerLeftElement}
                    </div>
                    {headerRightElement}
                    {collapsible && <Icon icon={isCollapsed ? fas.faChevronDown : fas.faChevronUp} />}
                </Card.Header>
            )}
            {!isCollapsed && (
                <>
                    <Card.Body className={dark ? "bg-canvas" : ""}>{children}</Card.Body>
                    {!!footer && <Card.Footer>{footer}</Card.Footer>}
                </>
            )}
        </Card>
    );
}
